export const T = {
  bg: '#09090b', paper: '#18181b', subtle: '#27272a',
  primary: '#3b82f6', accent: '#f97316',
  success: '#22c55e', warning: '#eab308', danger: '#ef4444', info: '#0ea5e9',
  border: '#27272a', borderActive: '#52525b',
  text: '#fafafa', textMuted: '#a1a1aa', textDim: '#71717a',
};

export const PIE_COLORS = [T.success, T.subtle];
